import { render, staticRenderFns } from "./HomePageFeatureBlackstar.vue?vue&type=template&id=9ae82df2&scoped=true&"
import script from "./HomePageFeatureBlackstar.vue?vue&type=script&lang=js&"
export * from "./HomePageFeatureBlackstar.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFeatureBlackstar.vue?vue&type=style&index=0&id=9ae82df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae82df2",
  null
  
)

export default component.exports